import api from './config/api';
import axios from './config/axios';

export default {
    /**
     * Get autoSuggestCustomer info
     * @param jwtToken
     * @param website
     * @param userAccountId
     * @param searchStr
     * @returns { AxiosPromise }
     */
    getAutoSuggestCustomer( {
        jwtToken,
        websiteId,
        userAccountId,
        searchStr,
    } ) {
        return axios( {
            url: api.logisticsUrl( `${ websiteId }/${ userAccountId }/mail/autoSuggestCustomer` ),
            method: 'get',
            headers: api.authHeaders( jwtToken ),
            params: {
                searchStr,
            },
        } );
    },

    /**
     * Get autoSuggestSender info
     * @param jwtToken
     * @param website
     * @param userAccountId
     * @param searchStr
     * @returns { AxiosPromise }
     */
    getAutoSuggestSender( {
        jwtToken,
        websiteId,
        userAccountId,
        searchStr,
    } ) {
        return axios( {
            url: api.logisticsUrl( `${ websiteId }/${ userAccountId }/mail/autoSuggestSender` ),
            method: 'get',
            headers: api.authHeaders( jwtToken ),
            params: {
                searchStr,
            },
        } );
    },

    /**
     * Get a list of mail carriers
     * @param jwtToken
     * @param website
     * @param userAccountId
     * @returns { AxiosPromise }
     */
    getMailCarriers( {
        jwtToken,
        websiteId,
        userAccountId,
    } ) {
        return axios( {
            url: api.logisticsUrl( `${ websiteId }/${ userAccountId }/mail/getCarriers` ),
            method: 'get',
            headers: api.authHeaders( jwtToken ),
        } );
    },

    /**
     * Validate a given tracking number
     * @param jwtToken
     * @param website
     * @param userAccountId
     * @param trackingNumber
     * @returns { AxiosPromise }
     */
    validateTrackingNumber( {
        jwtToken,
        websiteId,
        userAccountId,
        trackingNumber,
    } ) {
        return axios( {
            url: api.logisticsUrl( `${ websiteId }/${ userAccountId }/mailItem/validate/trackingNumber` ),
            method: 'get',
            headers: api.authHeaders( jwtToken ),
            params: {
                trackingNumber,
            },
        } );
    },

    /**
     * createMailLocators
     * @param jwtToken
     * @param website
     * @param userAccountId
     * @param numberOfDrawers
     * @param numberOfFoldersPerDrawer
     * @returns { AxiosPromise }
     */
    createMailLocators( {
        jwtToken,
        websiteId,
        userAccountId,
        numberOfDrawers,
        numberOfFoldersPerDrawer,
    } ) {
        return axios( {
            url: api.logisticsUrl( `${ websiteId }/${ userAccountId }/mail/createLocators` ),
            method: 'post',
            headers: api.authHeaders( jwtToken ),
            data: {
                numberOfDrawers,
                numberOfFoldersPerDrawer,
            },
        } );
    },

    /**
     * Get getMailItem info
     * @param jwtToken
     * @param website
     * @param userAccountId
     * @param mailItemRef
     * @returns { AxiosPromise }
     */
    getMailItemRef( {
        jwtToken,
        websiteId,
        userAccountId,
        mailItemRef,
    } ) {
        return axios( {
            url: api.logisticsUrl( `${ websiteId }/${ userAccountId }/mailItem/info/${ mailItemRef }` ),
            method: 'get',
            headers: api.authHeaders( jwtToken ),
        } );
    },

    /**
     * Get getLocator info
     * @param jwtToken
     * @param website
     * @param userAccountId
     * @param locatorRef
     * @returns { AxiosPromise }
     */
    getLocator( {
        jwtToken,
        websiteId,
        userAccountId,
        locatorRef,
    } ) {
        return axios( {
            url: api.logisticsUrl( `${ websiteId }/${ userAccountId }/mail/locator/${ locatorRef }` ),
            method: 'get',
            headers: api.authHeaders( jwtToken ),
        } );
    },

    /**
     * addMailToShelve
     * @param jwtToken
     * @param website
     * @param userAccountId
     * @param mailItemId
     * @param moveToLocatorId
     * @returns { AxiosPromise }
     */
    addMailToShelve( {
        jwtToken,
        websiteId,
        userAccountId,
        mailItemId,
        moveToLocatorId,
    } ) {
        return axios( {
            url: api.logisticsUrl( `${ websiteId }/${ userAccountId }/mailItem/shelve` ),
            method: 'post',
            headers: api.authHeaders( jwtToken ),
            data: {
                mailItemId,
                moveToLocatorId,
            },
        } );
    },
    /**
     * searchMailItems
     * @param jwtToken
     * @param website
     * @param userAccountId
     * @param customerId
     * @param sender
     * @params trackingNumber
     * @params mailTypeId
     * @params receivedDateStart
     * @params receivedDateEnd
     * @params locatorId
     * @params transType
     * @params cancelToken
     * @returns { AxiosPromise }
     */
    searchMailItems( {
        jwtToken,
        websiteId,
        userAccountId,
        customerId,
        sender,
        trackingNumber,
        mailTypeId,
        receivedDateStart,
        receivedDateEnd,
        locatorId,
        customerFilterTypeId,
        statusFilterTypeId,
        cancelToken,
    } ) {
        return axios( {
            cancelToken,
            url: api.logisticsUrl( `${ websiteId }/${ userAccountId }/mailItem/search` ),
            method: 'post',
            headers: api.authHeaders( jwtToken ),
            data: {
                customerId,
                sender,
                trackingNumber,
                mailTypeId,
                receivedDateStart,
                receivedDateEnd,
                locatorId,
                customerFilterTypeId,
                statusFilterTypeId,
            },
        } );
    },

    /**
     * @POST
     * Get Search Results as an exported file
     */
    getSearchResultsExport( {
        jwtToken,
        websiteId,
        userAccountId,
        customerId,
        sender,
        trackingNumber,
        mailTypeId,
        receivedDateStart,
        receivedDateEnd,
    } ) {
        return axios( {
            url: api.logisticsUrl( `${ websiteId }/${ userAccountId }/mailItem/search/export` ),
            method: 'post',
            headers: {
                ...api.authHeaders( jwtToken ),
                Accept: 'application/octet-stream',
            },
            data: {
                customerId,
                sender,
                trackingNumber,
                mailTypeId,
                receivedDateStart,
                receivedDateEnd,
            },
        } );
    },
    /**
     * getMailItemDetails
     * @param jwtToken
     * @param website
     * @param userAccountId
     * @param mailItemId
     * @returns { AxiosPromise }
     */
    getMailItemDetails( {
        jwtToken,
        websiteId,
        userAccountId,
        mailItemId,
    } ) {
        return axios( {
            url: api.logisticsUrl( `${ websiteId }/${ userAccountId }/mailItem/trackingHistory/${ mailItemId }` ),
            method: 'get',
            headers: api.authHeaders( jwtToken ),
        } );
    },
    /**
     * getMailItemTransactions
     * @param jwtToken
     * @param website
     * @param userAccountId
     * @param mailItemId
     * @returns { AxiosPromise }
     */
    getMailItemTransactions( {
        jwtToken,
        websiteId,
        userAccountId,
        mailItemId,
    } ) {
        return axios( {
            url: api.logisticsUrl( `${ websiteId }/${ userAccountId }/mailItem/transactions/${ mailItemId }` ),
            method: 'get',
            headers: api.authHeaders( jwtToken ),
        } );
    },
    /**
     * getMailTypes
     * @param jwtToken
     * @param website
     * @param userAccountId
     * @returns { AxiosPromise }
     */
    getMailTypes( {
        jwtToken,
        websiteId,
        userAccountId,
    } ) {
        return axios( {
            url: api.logisticsUrl( `${ websiteId }/${ userAccountId }/mailItem/types` ),
            method: 'get',
            headers: api.authHeaders( jwtToken ),
        } );
    },
    /**
     * addReceiveMail
     * @param jwtToken
     * @param website
     * @param userAccountId
     * @param receiveDate
     * @param mailCarrierId
     * @param mailTypeId
     * @params customerId
     * @params sender
     * @params transactionNotes
     * @params packageTrackingNumber
     * @params mailQuantity
     * @params photos
     * @returns { AxiosPromise }
     */
    addReceiveMail( {
        jwtToken,
        websiteId,
        userAccountId,
        receiveDate,
        mailCarrierId,
        mailTypeId,
        customerId,
        sender,
        transactionNotes,
        packageTrackingNumber,
        mailQuantity,
        photos,
    } ) {
        return axios( {
            url: api.logisticsUrl( `${ websiteId }/${ userAccountId }/mail/receive` ),
            method: 'post',
            headers: api.authHeaders( jwtToken ),
            data: {
                receiveDate,
                mailCarrierId,
                mailTypeId,
                customerId,
                sender,
                transactionNotes,
                packageTrackingNumber,
                mailQuantity,
                photos,
            },
        } );
    },

    /**
     * Void a mail item transaction
     * @param jwtToken
     * @param website
     * @param userAccountId
     * @param mailItemId { Number }
     * @param reason { String }
     */
    voidMailItem( {
        jwtToken,
        websiteId,
        userAccountId,
        mailItemId,
        reason,
    } ) {
        return axios( {
            url: api.logisticsUrl( `${ websiteId }/${ userAccountId }/mailItem/void` ),
            method: 'post',
            headers: api.authHeaders( jwtToken ),
            data: {
                mailItemId,
                reason,
            },
        } );
    },

    /**
     * getDynamicMailboxStatus
     * @param jwtToken
     * @param website
     * @param userAccountId
     * @returns { AxiosPromise }
     */
    getDynamicMailboxStatus( {
        jwtToken,
        websiteId,
        userAccountId,
    } ) {
        return axios( {
            url: api.logisticsUrl( `${ websiteId }/${ userAccountId }/mail/getDynamicMailboxStatus` ),
            method: 'get',
            headers: api.authHeaders( jwtToken ),
        } );
    },

    /**
     * getCustomerByNameOrId
     * @param jwtToken
     * @param website
     * @param userAccountId
     * @param externalRef
     * @param customerName
     * @returns { AxiosPromise }
     */
    getCustomerByNameOrId( {
        jwtToken,
        websiteId,
        userAccountId,
        externalRef,
        customerName,
    } ) {
        return axios( {
            url: api.logisticsUrl( `${ websiteId }/${ userAccountId }/mail/pickup/customer/choice/list` ),
            method: 'get',
            headers: api.authHeaders( jwtToken ),
            params: {
                externalRef: externalRef || null,
                customerName: customerName || null,
            },
        } );
    },
    /**
     * getCustomerPickupList
     * @param jwtToken
     * @param website
     * @param userAccountId
     * @params customerId
     * @returns { AxiosPromise }
     */
    getCustomerPickupList( {
        jwtToken,
        websiteId,
        userAccountId,
        customerId,
    } ) {
        return axios( {
            url: api.logisticsUrl( `${ websiteId }/${ userAccountId }/mail/pickup/list/${ customerId }` ),
            method: 'get',
            headers: api.authHeaders( jwtToken ),
        } );
    },
    /**
     * updateScannedPickupItems
     * @param jwtToken
     * @param website
     * @param userAccountId
     * @param mailItems
     * @param notes
     * @param photos
     * @params customerId
     * @returns { AxiosPromise }
     */
    updateScannedPickupItems( {
        jwtToken,
        websiteId,
        userAccountId,
        mailItems,
        notes,
        photos,
        customerId,
    } ) {
        return axios( {
            url: api.logisticsUrl( `${ websiteId }/${ userAccountId }/mail/pickup/trans` ),
            method: 'post',
            headers: api.authHeaders( jwtToken ),
            data: {
                mailItems,
                notes,
                photos,
                customerId,
            },
        } );
    },

    /**
     * printMailLabel
     * @param jwtToken
     * @param website
     * @param userAccountId
     * @param mailItemId
     * @returns { AxiosPromise }
     */
    printMailLabel( {
        jwtToken,
        websiteId,
        userAccountId,
        mailItemId,
    } ) {
        return axios( {
            url: api.logisticsUrl( `${ websiteId }/${ userAccountId }/mail/printLabel` ),
            method: 'get',
            headers: api.authHeaders( jwtToken ),
            params: {
                mailItemId,
            },
        } );
    },
    /**
     * getCustomerFilterTypes
     * @param jwtToken
     * @param website
     * @param userAccountId
     * @returns { AxiosPromise }
     */
    getCustomerTypes( {
        jwtToken,
        websiteId,
        userAccountId,
    } ) {
        return axios( {
            url: api.logisticsUrl( `${ websiteId }/${ userAccountId }/mailItem/customerFilterTypes` ),
            method: 'get',
            headers: api.authHeaders( jwtToken ),
        } );
    },
    /**
     * getStatusFilterTypes
     * @param jwtToken
     * @param website
     * @param userAccountId
     * @returns { AxiosPromise }
     */
    getStatusTypes( {
        jwtToken,
        websiteId,
        userAccountId,
    } ) {
        return axios( {
            url: api.logisticsUrl( `${ websiteId }/${ userAccountId }/mailItem/statusFilterTypes` ),
            method: 'get',
            headers: api.authHeaders( jwtToken ),
        } );
    },
};
